/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { baseRequest } from './baseRequest';
const baseInternalRoute = '/api/internal/reports';
export const getOpsStatsReport = async () => baseRequest.get(`${baseInternalRoute}/assignments`);